import { Component } from '@theme/component';
import { prefersReducedMotion } from '@theme/utilities';

class MobileDescPreview extends Component {
  scrollToDescription = (event) => {
    event.preventDefault();

    const target = this.closest('.product-details')?.querySelector('.product-description-content');

    if (!(target instanceof HTMLElement)) return;

    const accordionDetails = target.closest('details');

    if (accordionDetails instanceof HTMLDetailsElement) {
      accordionDetails.open = true;
    }

    requestAnimationFrame(() => {
      target.scrollIntoView({
        behavior: prefersReducedMotion() ? 'instant' : 'smooth',
        block: 'start',
      });
    });
  };
}

if (!customElements.get('mobile-desc-preview')) {
  customElements.define('mobile-desc-preview', MobileDescPreview);
}
